import {Action, applyMiddleware, combineReducers, compose, createStore, Store} from 'redux';

import messages from './message-box/message-box-reducer';
import {thunk, ThunkDispatch} from 'redux-thunk';
import {searchReducer} from './search/duck/search-reducer';
import {settingsReducer} from './settings/duck/settings-reducer';
import {configReducer} from './config/config-reducer';
import {backendTranslationsReducer} from './backendTranslations/backendTranslations-reducer';
import {assistantReducer} from './assistant/duck/assistant-reducer';
import {filterReducer} from './facets/duck/filter.reducer';

const appReducer = combineReducers({
    messages,
    search: searchReducer,
    settings: settingsReducer,
    config: configReducer,
    translations: backendTranslationsReducer,
    filter: filterReducer,
    assistant: assistantReducer
});

export type RootState = ReturnType<typeof appReducer>;

// Define AppDispatch type
export type AppDispatch = ThunkDispatch<RootState, void, Action>;

export const createFullStore = (): Store => {
    const rootReducer = (state, action) => appReducer(state, action);
    const composeEnhancers =
        (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    const storeEnhancer = composeEnhancers(applyMiddleware(thunk));
    return createStore(rootReducer, storeEnhancer);
};

export const store = createFullStore();
